var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "chat-title" }, [
      _vm._v(
        _vm._s(
          _vm.isKeyWord
            ? "聊天内容"
            : "与" + _vm.sendToRemark + "(" + _vm.sendTo + ")" + "的聊天"
        )
      )
    ]),
    _c("div", { ref: "ctx", staticClass: "chat-content" }, [
      _c(
        "div",
        { staticClass: "chat-list" },
        _vm._l(_vm.recordContent, function(itemc, indexc) {
          return _c("div", { key: indexc }, [
            !itemc.mineMsg
              ? _c("div", { staticClass: "word" }, [
                  _c("div", { staticClass: "time" }, [
                    _c("div", { staticClass: "nick-name" }, [
                      _vm._v(_vm._s(itemc.nickName))
                    ]),
                    _c("span", [_vm._v(_vm._s(itemc.timestamp))])
                  ]),
                  _c("div", { staticClass: "main" }, [
                    _c("img", {
                      staticClass: "userImage",
                      attrs: { src: itemc.headUrl }
                    }),
                    _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center",
                            "align-items": "center",
                            height: "100%"
                          }
                        },
                        [
                          itemc.msgType == "text"
                            ? _c("div", {
                                staticClass: "info-content",
                                domProps: {
                                  innerHTML: _vm._s(itemc.contactText)
                                }
                              })
                            : itemc.msgType == "voice"
                            ? _c("audio-record", {
                                attrs: { src: itemc.audioUrl, type: "left" }
                              })
                            : itemc.msgType == "file"
                            ? _c("file-record", {
                                attrs: {
                                  url: itemc.fileUrl,
                                  size: itemc.fileSize || "未知",
                                  fileType: itemc.fileExt,
                                  type: "left"
                                }
                              })
                            : itemc.msgType == "image" ||
                              itemc.msgType == "emotion"
                            ? _c("img-record", {
                                attrs: { src: itemc.imgUrl, type: "left" }
                              })
                            : itemc.msgType == "image" ||
                              itemc.msgType == "emotion"
                            ? _c(
                                "div",
                                { staticClass: "image" },
                                [
                                  _c("viewer", [
                                    _c("img", {
                                      staticStyle: {
                                        width: "auto",
                                        height: "auto",
                                        "max-width": "30%",
                                        "border-radius": "0%",
                                        "margin-top": "5px"
                                      },
                                      attrs: { src: itemc.imgUrl }
                                    })
                                  ])
                                ],
                                1
                              )
                            : itemc.msgType == "revoke"
                            ? _c("div", [
                                itemc.imgUrl
                                  ? _c(
                                      "div",
                                      { staticClass: "image" },
                                      [
                                        _c("viewer", [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "inline",
                                                position: "relative"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "auto",
                                                  height: "auto",
                                                  "max-width": "30%",
                                                  "border-radius": "0%",
                                                  "margin-top": "5px"
                                                },
                                                attrs: { src: itemc.imgUrl }
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "revoke-tip",
                                                  staticStyle: {
                                                    position: "absolute",
                                                    right: "0"
                                                  }
                                                },
                                                [_vm._v("已撤回")]
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c("div", {
                                          staticClass: "info-content",
                                          domProps: {
                                            innerHTML: _vm._s(itemc.contactText)
                                          }
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "revoke-tip" },
                                          [_vm._v("已撤回")]
                                        )
                                      ]
                                    )
                              ])
                            : _c("text-record", {
                                attrs: {
                                  content: itemc.contactText,
                                  type: "left"
                                }
                              })
                        ],
                        1
                      )
                    ])
                  ])
                ])
              : _c("div", { staticClass: "word-my" }, [
                  _c("div", { staticClass: "time" }, [
                    _c("div", { staticClass: "nick-name" }, [
                      _vm._v(_vm._s(itemc.nickName))
                    ]),
                    _c("span", [_vm._v(_vm._s(itemc.timestamp))])
                  ]),
                  _c("div", { staticClass: "main" }, [
                    _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-end",
                            "align-items": "center",
                            height: "100%"
                          }
                        },
                        [
                          itemc.msgType == "text"
                            ? _c("div", {
                                staticClass: "info-content",
                                domProps: {
                                  innerHTML: _vm._s(itemc.contactText)
                                }
                              })
                            : itemc.msgType == "voice"
                            ? _c("audio-record", {
                                attrs: { src: itemc.audioUrl, type: "right" }
                              })
                            : itemc.msgType == "file"
                            ? _c("file-record", {
                                attrs: {
                                  url: itemc.fileUrl,
                                  size: itemc.fileSize || "未知",
                                  fileType: itemc.fileExt,
                                  type: "right"
                                }
                              })
                            : itemc.msgType == "image" ||
                              itemc.msgType == "emotion"
                            ? _c("img-record", {
                                attrs: { src: itemc.imgUrl, type: "right" }
                              })
                            : itemc.msgType == "revoke"
                            ? _c("div", [
                                itemc.imgUrl
                                  ? _c(
                                      "div",
                                      { staticClass: "image" },
                                      [
                                        _c("viewer", [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "inline",
                                                position: "relative"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "auto",
                                                  height: "auto",
                                                  "max-width": "30%",
                                                  "border-radius": "0%",
                                                  "margin-top": "5px"
                                                },
                                                attrs: { src: itemc.imgUrl }
                                              }),
                                              _c(
                                                "div",
                                                { staticClass: "revoke-tip" },
                                                [_vm._v("已撤回")]
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c("div", {
                                          staticClass: "info-content",
                                          domProps: {
                                            innerHTML: _vm._s(itemc.contactText)
                                          }
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "revoke-tip" },
                                          [_vm._v("已撤回")]
                                        )
                                      ]
                                    )
                              ])
                            : _c("text-record", {
                                attrs: {
                                  content: itemc.contactText,
                                  type: "right"
                                }
                              })
                        ],
                        1
                      )
                    ]),
                    _c("span", { staticClass: "userImage" }, [
                      _vm._v(_vm._s(_vm.getAvatarName(itemc.nickName)))
                    ])
                  ])
                ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }